import styled from 'styled-components'

const Container = styled.div`
  position: fixed;
  width: 100vw;
  height: 44px;
  background-color: #fbe1c2;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
`

const Content = styled.div`
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #212121;
  margin-right: 72px;
`

const Button = styled.button`
  background: transparent;
  padding: 4px 12px;
  border-radius: 4px;
  border: solid 1px #000;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ButtonContent = styled.span`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  vertical-align: middle;
  color: #212121;
  cursor: pointer;
`

export { Button, Content, Container, ButtonContent }
